import { stationsActions } from '../reducer';

import { StationsState } from '../../types';

export const updateSelectedStation = (
  station?: StationsState['selectedStation']['data']
) => stationsActions.updateSelectedStation(station);
